<div class="progress-bar">
  <div class="bar-container">
    <div [className]="getCurrentClass() + ' horizontal-bar'" class="horizontal-bar"></div>
    <button class="circle left-circle" (click)="saveAndSubmit('/calculadora')">1</button>
    <button class="circle middle-circle" (click)="saveAndSubmit('/supuestos')">2</button>
    <button class="circle right-circle" (click)="saveAndSubmit('/resultados')">3</button>
    <!--    <a routerLink="/calculadora" (click)="printCurrentRoute()" class="circle left-circle">1</a>-->
    <!--    <a routerLink="/supuestos" (click)="printCurrentRoute()" class="circle middle-circle">2</a>-->
    <!--    <a routerLink="/resultados" (click)="printCurrentRoute()" class="circle right-circle">3</a>-->
  </div>

  <div class="text-container">
    <div class="left-text">Calculadora</div>
    <div class="middle-text">Supuestos</div>
    <div class="right-text">Resultados</div>
  </div>
  <!--  <a routerLink="/calculadora">-->
  <!--    <div class="circle">-->
  <!--      <div class="left-bar"></div>-->
  <!--      1-->
  <!--    </div>-->
  <!--    <div class="description">-->
  <!--      Calculadora-->
  <!--    </div>-->
  <!--  </a>-->

  <!--&lt;!&ndash;  <div class="calculator">&ndash;&gt;-->
  <!--&lt;!&ndash;  </div>&ndash;&gt;-->

  <!--  <a routerLink="/supuestos">-->
  <!--    <div class="circle">-->
  <!--      2-->
  <!--    </div>-->
  <!--    <div class="description">-->
  <!--      Supuestos-->
  <!--    </div>-->
  <!--  </a>-->

  <!--  <a routerLink="/resultados">-->
  <!--    <div class="circle">-->
  <!--      3-->
  <!--    </div>-->
  <!--    <div class="description">-->
  <!--      Resultados-->
  <!--    </div>-->
  <!--  </a>-->
</div>

<!--<mat-tab-group mat-align-tabs="center">-->
<!--  <mat-tab label="First">Content 1</mat-tab>-->
<!--  <mat-tab label="Second">Content 2</mat-tab>-->
<!--  <mat-tab label="Third">Content 3</mat-tab>-->
<!--</mat-tab-group>-->
